export const EducationAndTrainingEnum = {
    Education: "Education",
    Training: "Training",
    Certification: "Certification",
};